import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cos-form-line"
}
const _hoisted_2 = { class: "flex" }

import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { turnTransaction } from '@/api/overseasSales/customerCenter'
import GcCodeSelect from '@/components/GcCodeSelect'
import BusinessSelect from '@/components/BusinessSelect'
import { useRoute, useRouter } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import CosDatePicker from '@/components/CosDatePicker/index'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuTurnToDeal' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const formRef = ref()
const form = ref<{
  saleChance: {
    arkCode?: string
    contractCode?: string
    saleChanceubject?: string
    serviceSubject?: number
    cosId?: any
  }[]
}>({
  saleChance: [{}]
})
const permissionBasic = {
  save: 'ofbu_contract_deal_btn'
}
const resetValue = ref({
  saleChance: [{}]
})
const hanleAdd = () => {
  form.value.saleChance.push({})
}
const hanleDel = (index: number) => {
  form.value.saleChance.splice(index, 1)
}
const handleSubmit = () => {
  form.value.saleChance.forEach((item) => (item.cosId = route.query.cosId))
  turnTransaction(form.value.saleChance).then((res) => {
    layoutTags.close()
    message.success(t('tips.activitySuccess'))
    router.push({
      path: '/ofbu/contract'
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            name: "advanced_search",
            model: form.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_dc_layout_card, {
                title: _unref(t)('custom.turnToDealTitle'),
                span: 12
              }, {
                subTitle: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: hanleAdd,
                    ghost: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.saleChance, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      index
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.arkCode'),
                        span: 12,
                        name: ['saleChance', index, 'arkCodeId'],
                        rules: {
                message: _unref(t)('common.pleaseSelect'),
                required: true
              }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(GcCodeSelect), {
                            label: item.arkCode,
                            "onUpdate:label": ($event: any) => ((item.arkCode) = $event),
                            value: item.arkCodeId,
                            "onUpdate:value": ($event: any) => ((item.arkCodeId) = $event),
                            stage: [3, 4],
                            appId: "cos_ofbu",
                            cosId: _unref(route).query.cosId,
                            requiredCosId: true
                          }, null, 8, ["label", "onUpdate:label", "value", "onUpdate:value", "cosId"])
                        ]),
                        _: 2
                      }, 1032, ["label", "name", "rules"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.chanceName'),
                        span: 12,
                        name: ['saleChance', index, 'chanceId'],
                        rules: {
                message: _unref(t)('common.pleaseInput'),
                required: true
              }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BusinessSelect), {
                            value: item.chanceId,
                            "onUpdate:value": ($event: any) => ((item.chanceId) = $event),
                            arkCodeId: item.arkCodeId,
                            statusList: [1, 2, 4],
                            appId: "cos_ofbu",
                            saleChanceRefId: _unref(route).query.cosId
                          }, null, 8, ["value", "onUpdate:value", "arkCodeId", "saleChanceRefId"])
                        ]),
                        _: 2
                      }, 1032, ["label", "name", "rules"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.firstOrderId'),
                        span: 12,
                        name: ['saleChance', index, 'firstOrderId'],
                        rules: {
                message: _unref(t)('common.pleaseSelect'),
                required: true
              }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: item.firstOrderId,
                            "onUpdate:value": ($event: any) => ((item.firstOrderId) = $event),
                            placeholder: _unref(t)('common.pleaseInput')
                          }, null, 8, ["value", "onUpdate:value", "placeholder"])
                        ]),
                        _: 2
                      }, 1032, ["label", "name", "rules"]),
                      _createVNode(_component_dc_form_item, {
                        label: _unref(t)('custom.firstOrderTime'),
                        span: 12,
                        name: ['saleChance', index, 'firstOrderTime'],
                        rules: {
                message: _unref(t)('common.pleaseSelect'),
                required: true
              }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(CosDatePicker), {
                              value: item.firstOrderTime,
                              "onUpdate:value": ($event: any) => ((item.firstOrderTime) = $event),
                              isOutputBeijingTime: "",
                              showTime: true
                            }, null, 8, ["value", "onUpdate:value"]),
                            _withDirectives(_createVNode(_component_a_button, {
                              type: "text",
                              danger: "",
                              style: {"padding-right":"0px"},
                              onClick: ($event: any) => (hanleDel(index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]), [
                              [_vShow, form.value.saleChance && form.value.saleChance.length > 1]
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "name", "rules"])
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_cos_footer_button, {
            value: form.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form).value = $event)),
            formRef: formRef.value,
            permissionPage: permissionBasic,
            resetValue: resetValue.value,
            disabled: false,
            onSubmit: handleSubmit
          }, null, 8, ["value", "formRef", "resetValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})